import React from "react";
import vg from "../assets/2.webp";
import { AiFillGoogleCircle, AiFillAmazonCircle, AiFillInstagram,AiFillApple } from "react-icons/ai";

const Home = () => {
  return (
    <>
      <div className="home" id="home">
        <main>
          <h3>Next-Gen Tech</h3>
          <p>Solution of your all problem's</p>
        </main>
      </div>
      <div className="home2">
        <img src={vg} alt="Graphics" />
        <div>
          <p>
            We are your one and only solution to the tech problems you face
            every day. We are leading tech company whose aim is to increase the
            problem solving ability in children.
          </p>
        </div>
      </div>
      <div className="home3" id="about">
        <div>
          <h1>Who We Are</h1>
          <p>
            At NextGen Tech, we are a leading provider of cutting-edge IT solutions designed to drive your business forward. With a team of experienced professionals, we offer a comprehensive range of services that cater to your unique needs, ensuring your technology infrastructure is robust, secure, and scalable.
            Our solutions encompass everything from cloud computing and cybersecurity to custom software development and IT consulting. We pride ourselves on delivering high-quality, innovative solutions that help you stay ahead of the competition. Our commitment to excellence and customer satisfaction sets us apart in the industry.
            Whether you are a small startup or a large enterprise, we have the expertise and resources to support your business goals. At NextGen Tech, we believe in building long-term partnerships with our clients, providing reliable and efficient IT solutions that drive success and growth.
            Join us on a journey to technological excellence and let us help you navigate the complex world of IT with ease and confidence.
          </p>
        </div>

      </div >
      <div className="home4" id="brands">
        <div>
          <h1>Our Partner Brands</h1>

          <article>
            <div
              style={{
                animationDelay: "0s",
              }}
            >
              <AiFillGoogleCircle />
              <p>Google</p>
            </div>

            <div
              style={{
                animationDelay: "0.25s",
              }}
            >
              <AiFillAmazonCircle />
              <p>Amazon</p>
            </div>


            <div
              style={{
                animationDelay: "0.5s",
              }}
            >
              <AiFillInstagram />
              <p>Instagram</p>
            </div>

            <div
              style={{
                animationDelay: "1s",
              }}
            >
              <AiFillApple />
              <p>Apple</p>
            </div>
          </article>
        </div>
      </div>
    </>
  );
};

export default Home;
